import UserPage, { IUserPageAttrs } from 'flarum/forum/components/UserPage';
import Mithril from 'mithril';
import app from 'flarum/forum/app';
import listItems from 'flarum/common/helpers/listItems';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import UserReputationHistory from '../settings/UserReputationHistory';

export default class ReputationHistoryPage extends UserPage {
  oninit(vnode: Mithril.Vnode<IUserPageAttrs, this>) {
    super.oninit(vnode);
    // @ts-ignore
    this.loadUser(this.attrs.username || null);
  }

  oncreate(vnode: Mithril.VnodeDOM<IUserPageAttrs, this>) {
    super.oncreate(vnode);
  }

  view(): JSX.Element {
    return (
      <div className="UserPage">
        {this.user ? (
          <div className="container">
            <div className="sideNavContainer">
              <nav className="sideNav UserPage-nav">
                <ul>{listItems(this.sidebarItems().toArray())}</ul>
              </nav>
              <div className="sideNavOffset UserPage-content">
                <div className="PostsUserPage">
                  <h2>{app.translator.trans('justoverclock-reputation-score.forum.reputationHistory')}</h2>
                  <p>{app.translator.trans('justoverclock-reputation-score.forum.reputationHistoryPageTitle')}</p>
                  <UserReputationHistory userId={this.user.id()} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <LoadingIndicator display="block" />
        )}
      </div>
    );
  }
}
